import { CSSProperties, FC, ReactNode } from 'react';

import { FlexContentRegion, FullHeightFlexColumn } from '../../flex';

interface SmallResourceFooterLayoutProps {
    children: ReactNode;
    className?: string;
    contentClassName?: string;
    contentStyle?: CSSProperties;
    footer: ReactNode;
    style?: CSSProperties;
}

/**
 * Full-height page shell for compact platform footers.
 *
 * The content region owns scrolling and shrinking; the footer remains a fixed
 * sibling at the bottom of the available authenticated content area.
 */
const SmallResourceFooterLayout: FC<SmallResourceFooterLayoutProps> = ({
    children,
    className,
    contentClassName,
    contentStyle,
    footer,
    style,
}): JSX.Element => (
    <FullHeightFlexColumn className={className} style={style}>
        <FlexContentRegion
            className={contentClassName}
            style={{
                display: 'flex',
                flexDirection: 'column',
                ...contentStyle,
            }}
        >
            {children}
        </FlexContentRegion>
        {footer}
    </FullHeightFlexColumn>
);

export default SmallResourceFooterLayout;
